<template>
  <div class="panel-in-tab">
    <!-- 顶部标签页 -->
    <div class="tab-header">
      <el-tabs v-model="activeTopTab" @tab-click="handleTopTabClick" class="top-tabs">
        <el-tab-pane label="设计图" name="design"></el-tab-pane>
      </el-tabs>
    </div>
    
    <!-- 引入内容组件 -->
    <design-content v-if="activeTopTab === 'design'" @getNumber="getNumber" />
  </div>
</template>

<script>
import DesignContent from './components/DesignContent.vue';

export default {
  name: 'Obsoleted',
  components: {
    DesignContent
  },
  data() {
    return {
      activeTopTab: 'design',
    };
  },
  methods: {
    handleTopTabClick() {
      // 处理顶部标签页切换
    },
    getNumber() {
      // 更新数量
      this.$emit('getNumber');
    }
  }
};
</script>

<style lang="stylus" scoped>
.panel-in-tab {
  height: 100%;
}

.tab-header {
  margin-bottom: 10px;
}

.top-tabs {
  >>> .el-tabs__header {
    margin-bottom: 10px;
  }
}
</style>
